/** Build a Cookie header value from first-party Mautic cookies readable in the browser. */
export function buildMauticCookieHeader(): string {
  if (typeof document === 'undefined') return ''
  const names = ['mtc_id', 'mautic_device_id', 'mtc_sid']
  const parts: string[] = []
  for (const name of names) {
    const re = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`)
    const m = document.cookie.match(re)
    if (m?.[1]) {
      parts.push(`${name}=${decodeURIComponent(m[1].trim())}`)
    }
  }
  return parts.join('; ')
}

export function getUtmFromLocation(): {
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  utmContent?: string
  utmTerm?: string
} {
  if (typeof window === 'undefined') return {}
  const u = new URLSearchParams(window.location.search)
  const pick = (k: string) => {
    const v = u.get(k)
    return v && v.trim() ? v.trim() : undefined
  }
  return {
    utmSource: pick('utm_source'),
    utmMedium: pick('utm_medium'),
    utmCampaign: pick('utm_campaign'),
    utmContent: pick('utm_content'),
    utmTerm: pick('utm_term'),
  }
}
